// @ts-nocheck c36b8bdb
import _ from 'lodash';
import constants from '../constants/closeButtonsConstants';
import {
  accessibleStyle,
  accessibleCloseIconButtonSystemId,
} from './constants';

const mod = {};

function getIconButtonData(editorAPI) {
  const sections = editorAPI.addPanel.getSectionsByComponentType(
    constants.ICON_TYPE,
    null,
  );

  const items = sections?.[0]?.props?.items as Array<any>;
  const accessibleCloseIconButton = items.find(
    (item) => item.systemId === accessibleCloseIconButtonSystemId,
  );

  const structure =
    accessibleCloseIconButton?.structure ??
    sections?.[0]?.props?.items?.[0]?.structure;
  structure.layout = _.omit(structure.layout, ['x', 'y']);

  return structure;
}

function getTextButtonData(editorAPI) {
  const structure =
    editorAPI.addPanelInfra.componentsDefaultData.getComponentDefault(
      constants.TEXT_TYPE,
    );
  const style = accessibleStyle;
  structure.layout = structure.panelLayout;
  structure.style = style;

  delete structure.panelLayout;
  return structure;
}

mod[constants.ICON_TYPE] = getIconButtonData;
mod[constants.TEXT_TYPE] = getTextButtonData;

export default mod;
